// extracted by mini-css-extract-plugin
export default {"list":"ZKl6eS","item":"pfyzzS","link":"ji4k14","icon":"JEJZgj"};